import { createClient } from '@lumi.new/sdk'

export const lumi = createClient({
  projectId: 'p407865272583602176',
  apiBaseUrl: 'https://api.lumi.new',
  authOrigin: 'https://auth.lumi.new',
})
